import { MoreOutlined } from "@ant-design/icons";
import { Divider, Dropdown, Flex, Form, FormListFieldData } from "antd";
import { FC } from "react";
import { sanitizeIntegerInput } from "tm-shared/utils";

import { PrimaryText } from "@/components/Typography/Styled";

import { StyledInputNumber } from "../../Styled";
import { StyledMenuButton } from "./Styled";

interface ContractFacingsRowProps {
    finGroup: string;
    field: FormListFieldData;
    menuItems: {
        key: string;
        label: JSX.Element;
    }[];
    remove: (index: number) => void;
}

export const ContractFacingsRow: FC<ContractFacingsRowProps> = ({
    field,
    menuItems,
    finGroup,
    remove,
}) => {
    return (
        <Flex key={field.key} vertical gap={12}>
            <Flex justify="space-between" align="flex-start" gap={4}>
                <Flex flex={1} vertical gap={4}>
                    <Flex justify="space-between" align="center" gap={8}>
                        <PrimaryText>{finGroup}</PrimaryText>

                        <Form.Item
                            name={[field.name, "quantity"]}
                            style={{ marginBottom: 0 }}
                            rules={[
                                {
                                    required: true,
                                    message: "",
                                },
                            ]}
                        >
                            <StyledInputNumber
                                min={0}
                                parser={sanitizeIntegerInput}
                                style={{ width: 70 }}
                            />
                        </Form.Item>
                    </Flex>
                </Flex>

                <Dropdown
                    menu={{
                        items: menuItems,
                        onClick: () => remove(field.name),
                    }}
                >
                    <StyledMenuButton type="text" icon={<MoreOutlined />} />
                </Dropdown>
            </Flex>

            <Divider style={{ margin: 0 }} />
        </Flex>
    );
};
